export const search = {
  brand: 'Suchergebnisse',
  noProducts: 'Zu dieser Anfrage konnten keine Produkte gefunden werden.',
  resultsFor: 'Suchergebnisse für \"{searchString}\"',
  treasures: 'Unsere Kostbarkeiten',
  caption: {
    categories: 'Kategorien',
    query: 'Suchanfrage',
    results: 'Suchergebnisse',
  },
  scope: {
    format: 'Suche in {scope}',
    everywhere: 'Überall',
  },
  filter: {
    reset: 'Alle Filter zurücksetzen',
    toggleDetails: 'Filter',
    offerPrice: 'Aktionen',
    properties: 'Eigenschaften',
    price: 'Preis',
    priceRange: 'Preisspanne',
    property: {
      new: 'Neu',
      tiefgekuehlt: 'Tiefgekühlt',
      gekuehlt: 'Gekühlt',
      wiegeartikel: 'Wiegeartikel',
      bestellartikel: 'Vorbestellartikel',
      bio: 'Bio',
      msc: 'MSC',
      asc: 'ASC',
      unsere_kostbarkeiten: 'Unsere Kostbarkeiten',
      dauertiefpreis: 'Dauertiefpreis',
    },
  },
  emptyResult: 'Keine Produkte gefunden.',
  pagination: {
    currentProgress: '{current} von {total}',
    showMore: 'Mehr anzeigen',
    backToTop: 'Zurück zum Anfang',
  },
  suggestions: {
    items: 'Artikel',
    close: 'Suche schließen',
    moreMulti: '{moreProducts} weitere Artikel',
    moreSingle: '{moreProducts} weiterer Artikel',
  },
};

export const myProducts = {
  brand: 'Meine Produkte',
  logoCharacter: 'm',
};

export const browse = {
  brand: 'Sortiment',
  showAll: 'Alle Artikel anzeigen',
  categoryFilter: {
    back: 'Zurück',
  },
  overpack: 'Überverpackung',
};

export const detail = {
  back: 'Zurück',
  badges: {
    new: 'NEU',
    offer: 'AKTION',
    lowPrice: 'DAUERTIEFPREIS',
  },
  noSuchProduct: 'Dieses Produkt konnte nicht gefunden werden.',
  attributes: {
    productSku: 'Artikelnummer',
    netFillQuantity: 'Nettofüllmenge',
    basePrice: 'Grundpreis',
    description: 'Produktbeschreibung',
    ingredients: 'Inhaltsstoffe',
    alcohol: 'Alkoholgehalt',
    contact: 'Kontaktdaten',
    // These attributes are intentionally not written in camelCase, since the attributes are stored with a dash '-'.
    // For easier key matching, we just remove the dash "storage-note" -> "storagenote"
    storagenote: 'Aufbewahrungshinweis',
    preparationnote: 'Zubereitungshinweis',
    winegrower: 'Winzerbetrieb',
    wineregion: 'Weinregion',
  },
  links: {
    overview: 'Übersicht',
    description: 'Produktbeschreibung',
    nutrient: 'Nährwert',
    ingredients: 'Inhaltsstoffe, Aufbewahrungshinweis, Allergene',
    producer: 'Produzent',
  },
  nutrition: {
    title: 'Nährwerte',
    header: {
      serving: 'Pro Portion',
      oneHundred: 'Pro 100g',
      prepared: 'zubereitet',
      unPrepared: 'unzubereitet',
      amount: 'Menge',
      intake: '% ETB*',
    },
    labels: {
      energy: 'Energie',
      fat: 'Fett',
      choavl: 'Kohlenhydrate',
      fibtg: 'Ballaststoffe',
      pro: 'Eiweiß',
      salteq: 'Salz',
      fasat: 'davon gesättigte Fettsäuren',
      famscis: 'davon einfach ungesättigte Fettsäuren',
      fapucis: 'davon mehrfach ungesättigte Fettsäuren',
      polyl: 'davon mehrwertige Alkohole',
      starch: 'davon Stärke',
      sugar: 'davon Zucker',
    },
    referenceIntakeInfo: '* Referenzmenge für einen durchschnittlichen Erwachsenen (8.400 kJ / 2.000 kcal)',
  },
  allergens: {
    title: 'Allergene',
    contained: 'Enthaltene Allergene',
    traces: 'Enthaltene Allergenspuren',
    keys: {
      a: 'Glutenhaltige Getreide und daraus gewonnene Erzeugnisse',
      b: 'Krebstiere und daraus gewonnene Erzeugnisse',
      c: 'Eier und daraus gewonnene Erzeugnisse',
      d: 'Fisch und daraus gewonnene Erzeugnisse',
      e: 'Erdnüsse und daraus gewonnene Erzeugnisse',
      f: 'Sojabohnen und daraus gewonnene Erzeugnisse',
      g: 'Milch und daraus gewonnene Erzeugnisse',
      h: 'Schalenfrüchte und daraus gewonnene Erzeugnisse',
      l: 'Sellerie und daraus gewonnene Erzeugnisse',
      m: 'Senf und daraus gewonnene Erzeugnisse',
      n: 'Sesamsamen und daraus gewonnene Erzeugnisse',
      o: 'Schwefeldioxid und Sulfite',
      p: 'Lupine und daraus gewonnene Erzeugnisse',
      r: 'Weichtiere und daraus gewonnene Erzeugnisse',
    },
  },
};
